import React from 'react';
import { cn } from './cn';

/**
 * Tabs — điều hướng tab. variant: 'underline' (mặc định) | 'pills' | 'fullWidth'.
 * tabs: [{ value, label, icon?, badge? }] · controlled qua value + onChange.
 */
export function Tabs({ tabs = [], value, onChange, variant = 'underline', className }) {
  const isUnderline = variant === 'underline';
  const isPills = variant === 'pills';
  const isFull = variant === 'fullWidth';

  return (
    <div
      role="tablist"
      className={cn(
        // `relative`: chữ sr-only (position:absolute) trong tab nằm trong vùng cuộn này, nếu không thì nó
        // thoát khỏi vùng cắt và làm cả trang tràn ngang trên điện thoại.
        'relative',
        isUnderline && 'flex gap-1 border-b border-line overflow-x-auto',
        isPills && 'tab-strip gap-1 p-1 rounded-xl bg-surface-sunken',
        isFull && 'flex w-full rounded-lg shadow-xs',
        className
      )}
    >
      {tabs.map((tab, i) => {
        const active = tab.value === value;
        const Icon = tab.icon;
        return (
          <button
            key={tab.value}
            type="button"
            role="tab"
            aria-selected={active}
            onClick={() => onChange?.(tab.value)}
            className={cn(
              'inline-flex items-center justify-center gap-2 text-sm font-medium transition-all duration-150 whitespace-nowrap',
              isUnderline &&
                cn(
                  'px-4 py-3 border-b-2 -mb-px',
                  active
                    ? 'border-brand text-brand-fg'
                    : 'border-transparent text-body hover:text-heading hover:border-line-strong'
                ),
              isPills &&
                cn(
                  'px-4 py-2 rounded-lg',
                  active ? 'bg-brand text-white shadow-sm' : 'text-body hover:text-heading hover:bg-surface'
                ),
              isFull &&
                cn(
                  'flex-1 px-4 py-3 border border-line bg-surface',
                  i === 0 && 'rounded-l-lg',
                  i === tabs.length - 1 && 'rounded-r-lg',
                  i > 0 && '-ml-px',
                  active ? 'bg-surface-sunken text-brand-fg z-10' : 'text-body hover:bg-surface-sunken hover:text-heading'
                )
            )}
          >
            {Icon ? <Icon className="w-4 h-4" aria-hidden="true" /> : null}
            {tab.label}
            {tab.badge != null ? (
              <span
                className={cn(
                  'ml-1 inline-flex items-center justify-center min-w-[18px] h-[18px] px-1 rounded-full text-[11px] font-semibold',
                  active ? 'bg-white/20 text-current' : 'bg-gray-200 text-gray-700 dark:bg-gray-700 dark:text-gray-200'
                )}
              >
                {tab.badge}
              </span>
            ) : null}
          </button>
        );
      })}
    </div>
  );
}

export default Tabs;
